import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import PlayButton from './ui/PlayButton';
import LoadingBar from './ui/LoadingBar';
import ImageDisplay from './ui/ImageDisplay';
import PaginationButtons from './PaginationButtons';
import NoResults from './ui/NoResults';

import config from './../config';
import helpers from './../lib/helpers';

function BookPageList(props) {
	const [data, setData] = useState(null);
	const [currentUrl, setCurrentUrl] = useState(null);
	const [nextUrl, setNextUrl] = useState(null);
	const [previousUrl, setPreviousUrl] = useState(null);
	const [resultCount, setResultCount] = useState(0);
	const [loading, setLoading] = useState(true);
	const [songTitle, setSongTitle] = useState(null);
	const [songId, setSongId] = useState(null);
	const [stanzaTitle, setStanzaTitle] = useState(null);
	const [stanzaId, setStanzaId] = useState(null);

	const history = useHistory();

	useEffect(() => {
		if (!data) {
			fetchData();
		}
	});

	useEffect(() => {
		fetchData();
	}, [props.book, props.searchParams]);

	const fetchData = (url) => {
		setLoading(true);

		let urlParams = [];

		if (props.book) {
			urlParams.push('book='+props.book);
		}

		if (props.searchParams) {
			let params = helpers.parseSearchParams(props.searchParams)

			if (params.sida) {
				urlParams.push('offset='+(2*(params.sida-1)))
			}

			if (params.syna) {
				urlParams.push('page_id='+params.syna)
			}

			if (params.titill_erindis) {
				setStanzaTitle(params.titill_erindis);
			}
			else {
				setStanzaTitle(null);
			}

			if (params.erindi) {
				setStanzaId(params.erindi);
			}
			else {
				setStanzaId(null);
			}

			if (params.titill_lags) {
				setSongTitle(params.titill_lags);
			}
			else {
				setSongTitle(null);
			}

			if (params.lag) {
				setSongId(params.lag);
			}
			else {
				setSongId(null);
			}
		}

		urlParams.push('limit=2');

		let fetchUrl = url || (config.apiRoot+'/api/bookpage/?'+urlParams.join('&'));

		setCurrentUrl(fetchUrl);

		helpers.fetch(fetchUrl, (json) => {
			if (json) {
				setData(json.results);
				setNextUrl(json.next);
				setPreviousUrl(json.previous);
				setResultCount(json.count);

				if (props.onResponse) {
					props.onResponse(json.results);
				}
			}
			setLoading(false);
		});
	}

	return (
		<div className={'position-relative '+(props.className || '')+(loading ? ' loading' : '')}>
			<LoadingBar />
			{
				data && data.length > 0 &&
				<React.Fragment>
					{
						props.children
					}
					{
						(songId || stanzaId) && (() => {
							let params = helpers.parseSearchParams(props.searchParams);

							return <p>
								{
									songId && <React.Fragment>Sýnir síðu með laginu <Link to={helpers.routerUrls['log']+songId}>{songTitle}</Link>.</React.Fragment>
								}
								{
									stanzaId && <React.Fragment>Sýnir síðu með erindinu <Link to={helpers.routerUrls['erindi']+stanzaId}>{stanzaTitle}</Link>.</React.Fragment>
								}
								<br/><br/><button className="btn btn-primary" onClick={() => {
									setSongTitle(null);
									setSongId(null);
									setStanzaTitle(null);
									setStanzaId(null);

									history.push(helpers.routerUrls['baekur']+props.book);
								}}>Sýna allar síður</button>
							</p>
						})()
					}
					<div className="row mb-4">
						{
							data.map((item, index) => <div key={index} className="col col-12 col-md-6">
								{
									item.files && item.files.length > 0 &&
									<React.Fragment>
										<ImageDisplay src={config.mediaUrl+item.files[0].path} title={item.number || item.name} />
										{
											item.stanza && item.stanza.length > 0 &&
											<div>
												<table className="table metadata-table">
													<tr><th>Erindi á þessari síðu</th></tr>
													<tr><td>{helpers.metadataList(item.stanza, helpers.routerUrls['erindi'], 'id', 'first_line')}</td></tr>
												</table>
											</div>
										}
										{
											item.songs && item.songs.length > 0 &&
											<div>
												<table className="table metadata-table">
													<tr><th>Lög á þessari síðu</th></tr>
													<tr><td>{helpers.metadataList(item.songs, helpers.routerUrls['log'], 'id', 'headline')}</td></tr>
												</table>
											</div>
										}
									</React.Fragment>
								}
							</div>)
						}
					</div>
					{
						resultCount > 2 &&
						<PaginationButtons resultCount={resultCount}
							previousUrl={previousUrl}
							nextUrl={nextUrl}
							pageSize={2} />
						/*
						<PaginationButtons disableRouter={true}
							resultCount={resultCount}
							currentUrl={currentUrl}
							previousUrl={previousUrl}
							nextUrl={nextUrl}
							pageSize={2}
							onPageScroll={(url) => {
								fetchData(url);
							}} />
						*/
					}
				</React.Fragment>
			}
			{
				data && data.length == 0 && !loading &&
				<NoResults />
			}
		</div>
	)
}

export default BookPageList;
